import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Gym } from 'src/app/model/gym';
import { GymUtils } from 'src/app/util/gym-util';

@Component({
  selector: 'gymfinder-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  standalone: false,
})
export class ContactInfoComponent {
  @Input()
  gym: Gym;

  @Input()
  editMode: boolean;

  @Output()
  gymChange = new EventEmitter<Gym>();

  instagramRegex = GymUtils.INSTAGRAM_USERNAME_REGEX;

  public get email(): string | undefined {
    return this.gym.email;
  }

  public set email(value: string | undefined) {
    this.gym.email = value;
    this.gymChange.emit(this.gym);
  }

  public get phone(): string | undefined {
    return this.gym.phone;
  }

  public set phone(value: string | undefined) {
    this.gym.phone = value;
    this.gymChange.emit(this.gym);
  }

  get instagram(): string | undefined {
    return this.gym.instagram;
  }

  public set instagram(value: string | undefined) {
    this.gym.instagram = value;
    this.gymChange.emit(this.gym);
  }
  get website(): string | undefined {
    return this.gym.website;
  }

  public set website(value: string | undefined) {
    this.gym.website = value;
    this.gymChange.emit(this.gym);
  }
}
